module.exports = {"360421100":"沙河街镇","360421101":"马回岭镇","360421102":"江洲镇","360421103":"城子镇","360421104":"港口街镇","360421105":"新合镇","360421106":"狮子镇","360421200":"永安乡","360421201":"涌泉乡","360421202":"新塘乡","360421203":"城门乡","360421204":"岷山乡","360421403":"沙河经济技术开发区","360421501":"新洲垦殖场","360421502":"赛城湖水产场","360421503":"岷山林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360421.json
// module id = 1169
// module chunks = 0